import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import {engravedPlateExtendedStore} from './engraved-plate-extended.store';
import {PCS_CSS, ProductCustomizationState} from '../../../rendering/render.def';
import {isNullOrWhiteSpace} from '../../../../util';

type Props = {
    css: PCS_CSS;
    pcs: ProductCustomizationState;
};

export const EPLines: React.FC<Props> = observer(({pcs, css}: Props) => {
    const baseLines = [1, 2, 3];
    const extendedLines = pcs.ProductID === 25466 ? [4, 5, 6, 7, 8, 9, 10] : [];
    const linesToRender = [...baseLines, ...extendedLines];

    const getLineStyle = useCallback(
        (idx: number) => {
            const value = pcs[`EP_${idx}`];
            const line = engravedPlateExtendedStore.lines[idx - 1];

            if (!value || isNullOrWhiteSpace(value)) {
                return {
                    lineHeight: `${pcs.DPI}px`,
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontFamily: engravedPlateExtendedStore.fontFamily,
                };
            }

            return {
                lineHeight: `${(line?.lineHeight ?? 1) * pcs.DPI}px`,
                fontSize: line?.size ? line?.size / 2 : 8,
                fontWeight: line?.bold ? 700 : 400,
                fontStyle: line?.italic ? 'italic' : 'normal',
                fontFamily: engravedPlateExtendedStore.fontFamily,
            };
        },
        [pcs, css],
    );

    const epLinesStyle: React.CSSProperties = {
        fontSize: css.ep_lines_fontSize,
        width: css.ep_lines_width,
        height: css.ep_lines_height,
        lineHeight: pcs.ProductID !== 25466 ? css.ep_lines_lineHeight : undefined,
    };

    return (
        <div
            id="ep_lines"
            style={epLinesStyle}
        >
            {linesToRender.map(idx => {
                const value = pcs[`EP_${idx}`];

                if (!value) return null;

                return (
                    <div
                        key={idx}
                        id={`ep_line${idx}`}
                        style={pcs.ProductID === 25466 ? getLineStyle(idx) : undefined}
                    >
                        {value}
                    </div>
                );
            })}
        </div>
    );
});
